import { getAccountsViewFilterNew, requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
import { forEachEntityRow } from '../../../../backend/utils';
import { flatten } from '../../../../backend/utils/FilterUtils';
import { AuthError } from '@juvare/platform-app/App';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { changeAccountStatusBulkActionType } from '../shared';
import { accountEntityName } from '../shared/entities/accountTypes';
export const changeAccountStatus = defineBulkAction({
    type: changeAccountStatusBulkActionType,
    onAuthBulkAction: (appContext, { createdBy, data }) => {
        const { userState } = appContext;
        if (!requireAnySystemPermission(userState, 'manage-accounts')) {
            throw new AuthError('Unauthorized');
        }
        const actionOwnerSystemLevel = appContext.appState.settings.systemRoleMap[userState.systemRole].level;
        return {
            secureFilter: [...getAccountsViewFilterNew(userState), { op: '!=', id: createdBy }, ...data.params.filter],
            initiatorSystemRoleLevel: actionOwnerSystemLevel,
        };
    },
    onProcessBulkAction: (appContext, { data, isCancelled, updateTotalCount, updateProcessedCount }) => {
        var _a;
        const accountStorage = appContext.storage(accountEntityName);
        const request = { filter: data.secureParams.secureFilter, orderBy: (_a = data.params.orderBy) !== null && _a !== void 0 ? _a : [{ column: 'email' }] };
        const actionOwnerSystemLevel = data.secureParams.initiatorSystemRoleLevel;
        const flatFilter = flatten(data.secureParams.secureFilter).filter((f) => 'column' in f && f.column === 'systemStatus');
        const statusValues = [...new Set(flatFilter.flatMap((f) => 'value' in f && f.value))];
        forEachEntityRow(accountStorage, request, (row, idx) => {
            if (appContext.appState.settings.systemRoleMap[row.columns.systemRole].level <= actionOwnerSystemLevel) {
                accountStorage.post({
                    action: 'partial-update',
                    id: row.id,
                    data: { systemStatus: data.params.newStatus },
                    actionParams: {
                        bulkAction: true,
                    },
                });
            }
            updateProcessedCount(idx + 1);
            const isDeleted = data.params.newStatus === 'deleted' ||
                (statusValues.includes(row.columns.systemStatus) && !statusValues.includes(data.params.newStatus));
            return { cancel: isCancelled(), deleted: isDeleted };
        }, updateTotalCount);
    },
});
